<template>
  <div
    class="sidebar-li"
    v-bind:class="{ clickable: !!onClick }"
    @click="onClick && onClick(mappable)"
  >
    <div class="sidebar-badge">
      <badge
        :src="mappable.badgeSrc"
        :number="numberOfTypes"
        :whiteNumber="true"
      />
    </div>
    <div class="details">
      <div class="name">{{ mappable.name }}</div>
      <div class="small coords">
        LAT {{ mappable.latShort }} / LONG {{ mappable.lngShort }}
      </div>
      <div class="small">
        {{ commaDelimitedTypes || 'N/A' }}
      </div>
    </div>
  </div>
</template>

<script>
import Badge from './badge';

export default {
  components: {
    Badge,
  },

  props: {
    mappable: Object,
    onClick: Function,
  },

  computed: {
    numberOfTypes() {
      return this.mappable.typesLength;
    },

    commaDelimitedTypes() {
      const { types } = this.mappable;
      return types.join(', ');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/variables';

.sidebar-li {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0.75rem;

  & .sidebar-badge {
    margin-right: 1.3rem;
    padding-top: 0.25rem;
  }

  & .details {
    overflow: hidden;
    padding-right: 12px;

    & .name {
      font-family: Roboto;
      font-size: 12.8px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      color: rgba(0, 0, 0, 0.87);
      margin-bottom: 0.25rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      left: 0;
      right: 0;
    }
  }

  & div.small {
    font-family: Roboto;
    font-size: 9.6px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: $small-text-color;
    display: block;

    &.coords {
      margin-bottom: 0.25rem;
    }
  }
}

.clickable {
  cursor: pointer;
}
</style>
